import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import type { TweetMetrics, Tweet as TweetType } from '@/types/tweet';
import { useEngagementSummary } from '../sections/useEngagementSummary';
import { useTopicSummary } from '../sections/useTopicSummary';
import type { InlineTweetReference, StreamState, TweetSummarySection } from '../types';
export function useTweetSummarySections(t0) {
  const $ = _c(31);
  const {
    tweet,
    metrics,
    inlineTweetUrls,
    summaryState,
    explanationState
  } = t0;
  const t1 = metrics.bookmarkCount ?? null;
  const t2 = metrics.impressionCount ?? null;
  let t3;
  if ($[0] !== metrics.likeCount || $[1] !== metrics.quoteCount || $[2] !== metrics.replyCount || $[3] !== metrics.retweetCount || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      likeCount: metrics.likeCount,
      retweetCount: metrics.retweetCount,
      replyCount: metrics.replyCount,
      quoteCount: metrics.quoteCount,
      bookmarkCount: t1,
      impressionCount: t2
    };
    $[0] = metrics.likeCount;
    $[1] = metrics.quoteCount;
    $[2] = metrics.replyCount;
    $[3] = metrics.retweetCount;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const engagement = useEngagementSummary(t3);
  let t4;
  if ($[7] !== inlineTweetUrls || $[8] !== tweet) {
    t4 = {
      tweet,
      inlineTweetUrls
    };
    $[7] = inlineTweetUrls;
    $[8] = tweet;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const topics = useTopicSummary(t4);
  let t5;
  bb0: {
    const t6 = summaryState.status === "complete" && summaryState.text ? "Ready" : summaryState.status;
    let t7;
    if ($[10] !== t6) {
      t7 = {
        label: "Summary",
        value: t6
      };
      $[10] = t6;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    const t8 = explanationState.status === "complete" && explanationState.text ? "Ready" : explanationState.status;
    let t9;
    if ($[12] !== t8) {
      t9 = {
        label: "Explanation",
        value: t8
      };
      $[12] = t8;
      $[13] = t9;
    } else {
      t9 = $[13];
    }
    let t10;
    if ($[14] !== t7 || $[15] !== t9) {
      t10 = {
        id: "summary-status",
        title: "Summary status",
        items: [t7, t9]
      };
      $[14] = t7;
      $[15] = t9;
      $[16] = t10;
    } else {
      t10 = $[16];
    }
    let t11;
    if ($[17] !== engagement.engagementRate) {
      t11 = engagement.engagementRate && engagement.engagementRate > 0 ? `Engagement rate ${(engagement.engagementRate * 100).toFixed(2)}%` : null;
      $[17] = engagement.engagementRate;
      $[18] = t11;
    } else {
      t11 = $[18];
    }
    let t12;
    if ($[19] !== engagement.items || $[20] !== t11) {
      t12 = {
        id: "engagement",
        title: "Engagement overview",
        items: engagement.items,
        footer: t11
      };
      $[19] = engagement.items;
      $[20] = t11;
      $[21] = t12;
    } else {
      t12 = $[21];
    }
    let t13;
    if ($[22] !== t10 || $[23] !== t12) {
      t13 = [t10, t12];
      $[22] = t10;
      $[23] = t12;
      $[24] = t13;
    } else {
      t13 = $[24];
    }
    const sections = t13;
    if (topics.items.length === 0) {
      t5 = sections;
      break bb0;
    }
    const t14 = topics.referenceCount > 0 ? `${topics.referenceCount} inline reference(s)` : null;
    let t15;
    if ($[25] !== t14 || $[26] !== topics.items) {
      t15 = {
        id: "topics",
        title: "Topics & context",
        items: topics.items,
        footer: t14
      };
      $[25] = t14;
      $[26] = topics.items;
      $[27] = t15;
    } else {
      t15 = $[27];
    }
    let t16;
    if ($[28] !== sections || $[29] !== t15) {
      t16 = [...sections, t15];
      $[28] = sections;
      $[29] = t15;
      $[30] = t16;
    } else {
      t16 = $[30];
    }
    t5 = t16;
  }
  return t5;
}